
export default {
    mounted(el, binding) {
        // Текст тултипа, расположение и смещение.
        const { placement, offset } = parseDirectiveArg(binding.arg);

        el._tooltipValue = binding.value;
        el._tooltipPlacement = placement;
        el._tooltipOffset = offset;

        el._showTooltip = () => {
            if (!el._tooltipValue) return;

            const tooltip = document.createElement("div");
            const isHTML = typeof el._tooltipValue === "string" && /<\/?[a-z][\s\S]*>/i.test(el._tooltipValue);
            
            // Проверяем, есть ли HTML тэги. Если есть, используем innerHTML, иначе textContent (задача 2021)
            if (isHTML) {
                tooltip.innerHTML = el._tooltipValue;
            } else {
                tooltip.textContent = el._tooltipValue;
            }
            
            tooltip.style.position = "fixed";
            tooltip.style.padding = isHTML ? "10px 14px" : "5px 8px"; // задача 2021
            tooltip.style.background = "#FFF";
            tooltip.style.color = "#373D3F";
            tooltip.style.borderRadius = "8px";
            tooltip.style.zIndex = "999999";
            tooltip.style.fontSize = "12px";
            tooltip.style.fontWeight = "400";
            tooltip.style.boxShadow = "1px 2px 10px 0px #131E2726";
            tooltip.style.visibility = "hidden";
            tooltip.style.whiteSpace = "pre-wrap";
            tooltip.style.maxWidth = "402px";
            tooltip.style.lineHeight = "1.4";
            
            // Странный баг: чтобы italic и bold корректно отображались внутри tooltip (задача 2021)
            const italicElements = tooltip.querySelectorAll("i, em");
            italicElements.forEach(el => {
                el.style.fontStyle = "italic";
                el.style.fontSize = "inherit";
            });
            const boldElements = tooltip.querySelectorAll("b, strong");
            boldElements.forEach(el => {
                el.style.fontWeight = "500";
                el.style.fontSize = "inherit";
            });

            // Устанавливаем корректное расстояние между параграфами (задача 2021)
            const paragraphElements = tooltip.querySelectorAll("p");
            paragraphElements.forEach((el, index) => {
                el.style.margin = "0";
                el.style.fontSize = "inherit";
                el.style.fontWeight = "inherit";
                el.style.lineHeight = "inherit";
                if (index > 0) {
                    el.style.marginTop = "6px";
                }
            });

            document.body.appendChild(tooltip);
            el._tooltipElement = tooltip;

            // Measure tooltip size
            const rect = el.getBoundingClientRect();
            const ttRect = tooltip.getBoundingClientRect();
            const offset = el._tooltipOffset;
            let top, left;

            switch (el._tooltipPlacement) {
                case "top":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.left + (rect.width - ttRect.width) / 2;
                    break;
                case "top-left":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.left;
                    break;
                case "top-right":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.right - ttRect.width;
                    break;
                case "bottom-left":
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.left;
                    break;
                case "bottom-right":
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.right - ttRect.width;
                    break;
                case "left-top":
                    top = window.scrollY + rect.top;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "left-bottom":
                    top = window.scrollY + rect.bottom - ttRect.height;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "right-top":
                    top = window.scrollY + rect.top;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "right-bottom":
                    top = window.scrollY + rect.bottom - ttRect.height;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "left":
                    top = window.scrollY + rect.top + (rect.height - ttRect.height) / 2;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "right":
                    top = window.scrollY + rect.top + (rect.height - ttRect.height) / 2;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "bottom":
                default:
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.left + (rect.width - ttRect.width) / 2;
            }

            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            tooltip.style.visibility = "visible";
        };

        el._hideTooltip = () => {
            if (el._tooltipElement) {
                document.body.removeChild(el._tooltipElement);
                el._tooltipElement = null;
            }
        };

        el.addEventListener("mouseenter", el._showTooltip);
        el.addEventListener("mouseleave", el._hideTooltip);
        el.addEventListener("click", el._hideTooltip, true);
    },

    updated(el, binding) {
        el._tooltipValue = binding.value;
        const { placement, offset } = parseDirectiveArg(binding.arg);
        el._tooltipPlacement = placement;
        el._tooltipOffset = offset;

        // Hide current tooltip if visible and recreate it
        if (el._tooltipElement) {
            el._hideTooltip();
            // If mouse is still over element, show tooltip again
            if (el.matches(":hover")) {
                // Use setTimeout to ensure DOM is updated
                setTimeout(() => {
                    el._showTooltip();
                }, 0);
            }
        }
    },

    unmounted(el) {
        el.removeEventListener("mouseenter", el._showTooltip);
        el.removeEventListener("mouseleave", el._hideTooltip);
        el.removeEventListener("click", el._hideTooltip, true);
        if (el._tooltipElement) {
            document.body.removeChild(el._tooltipElement);
            el._tooltipElement = null;
        }
        delete el._showTooltip;
        delete el._hideTooltip;
        delete el._tooltipValue;
        delete el._tooltipPlacement;
        delete el._tooltipOffset;
    }
};

function parseDirectiveArg(arg) {
    const defaultPlacement = "bottom";
    const defaultOffset = 11;

    // Если отсутствуют аргументы, возврат значений по умолчанию.
    if (!arg) {
        return { placement: defaultPlacement, offset: defaultOffset };
    }

    const argumentParts = arg.split(":");

    // Если передан 1 аргумент.
    if (argumentParts.length === 1) {
        const part = argumentParts[0];

        // Если это число, то это смещение.
        const numValue = parseInt(part[0], 10);

        if (!isNaN(numValue)) {
            return { placement: defaultPlacement, offset: numValue };
        }
        // Иначе это расположение.
        return { placement: part, offset: defaultOffset };
    }

    // Если переданы оба аргумента. placement:offset
    if (argumentParts.length === 2) {
        const placement = argumentParts[0];
        const offset = parseInt(argumentParts[1], 10);
        return {
            placement,
            offset: isNaN(offset) ? defaultOffset : offset
        };
    }

    // Иначе возврат значений по умолчанию.
    return { placement: defaultPlacement, offset: defaultOffset };

}